/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useEffect, useRef, useState } from 'react';
import { CONTENT_TYPE } from '../../../constants/globalConstants';
import { buildImgUrl, getSponsorData, getStatsBarData } from '../../../utils/utils';
import Modal from '../../Common/Modal';
import Sponsor from '../../Common/Sponsor';
import StatsBar from '../../Common/StatsBar';
import { VIDEO_MODAL } from '../../../constants/containerConstants';
import Video from '../../Cards/Video';
import { withTranslation } from 'react-i18next';
import ContentAccessModal from '../../Common/ContentAccessModal';
import UpSell from '../../Common/UpSell';
import * as track from '../../../utils/analytics';
import Transcript from '../../Common/Transcript';
import { pauseOnNextPrev, playOnNextPre } from '../../../utils/brightcove';

const VideoDetailModal = (props) => {
  const [showTranscript, setShowTranscript] = useState(false);
  const [portraitClass, setPortraitClass] = useState('');
  const containerRef = useRef(null);
  const { closeModal, videoData, itemid, isDestinationPage, onClose, t, isMediaPlaying } = props;
  const sponsorInfo = videoData.Sponsorby && getSponsorData(videoData.Sponsorby.fields);

  useEffect(() => {
    if (containerRef.current) {
      const vD =
        videoData &&
        videoData.VideoFile &&
        videoData.VideoFile.value &&
        videoData.VideoFile.value.Orientation;
      if (vD) {
        const splittedVal = vD.split('x');
        let vH = +splittedVal[1];
        let vW = +splittedVal[0];
        if (vW > vH) {
          setPortraitClass('landscape');
        } else {
          setPortraitClass('portrait-inline');
        }
      }
    }
  }, [containerRef]);

  const toggleTranscript = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (containerRef && containerRef.current) {
      const videoAttr = containerRef.current.querySelector('video-js');
      if (videoAttr) {
        const videoAttrId = videoAttr.getAttribute('id');
        !showTranscript ? pauseOnNextPrev(videoAttrId) : playOnNextPre(videoAttrId);
      }
    }
    setShowTranscript(!showTranscript);
  };

  const transcriptOnkeypress = (e) => {
    const code = e.keyCode || e.which;
    if (code === 32 || code === 13) {
      toggleTranscript();
    }
  };

  const renderSponsor = () => {
    return (
      <Sponsor
        contentType={videoData.ContentType && videoData.ContentType.value}
        varient={videoData.Variant && videoData.Variant.value}
        sponsorInfo={sponsorInfo}
        grid={'grid-12'}
        type={CONTENT_TYPE}
        author={videoData.Author && videoData.Author.value}
        cardName={videoData.ShortHeadline && videoData.ShortHeadline.value}
        container={VIDEO_MODAL}
        createdDateTime={videoData.__Published && videoData.__Published.value}
        itemId={itemid}
        tags={videoData.manutds && videoData.manutds.value && videoData.manutds.value.Tags}
      />
    );
  };

  const getAnalyticsData = () => {
    const initialData = track.data('card');
    return {
      ...initialData,
      card_name: videoData.ShortHeadline && videoData.ShortHeadline.value,
      item_id: itemid,
      content_type: videoData.ContentType && videoData.ContentType.value,
      tag: videoData.manutds && videoData.manutds.value && videoData.manutds.value.Tags,
      created_datetime: videoData.__Published && videoData.__Published.value,
      author: videoData.Author && videoData.Author.value,
      destination_url:
        videoData.manutds && videoData.manutds.value && videoData.manutds.value.DestinationUrl,
    };
  };

  return (
    <Modal
      closeModal={closeModal}
      onClose={isDestinationPage && onClose}
      modalType="image-modal"
      containerClass="modal-page modal-page__content"
    >
      {isDestinationPage && (
        <ContentAccessModal
          ContentAccess={videoData && videoData.ContentAccess && videoData.ContentAccess.value}
          ContentType={videoData && videoData.ContentType && videoData.ContentType.value}
          manutds={videoData && videoData.manutds}
          className={`video-non-des`}
          insideModal={true}
          isDestinationPage={isDestinationPage}
          analyticsObj={getAnalyticsData()}
        />
      )}
      <div className="video-non-des">
        {renderSponsor()}
        <div ref={containerRef} className={`home-article-detail__video-panel ${portraitClass}`}>
          <Video
            gridClass="grid-7"
            isInlineVideo={true}
            fields={videoData}
            showStatsbar={false}
            isDestinationPage={true}
            noVariant={true}
            isCloseIcon={true}
            isMediaPlaying={isMediaPlaying}
          />
          <div className="sponsor-mobile">{renderSponsor()}</div>
          <div className="modalTranscriptSection">
            <h1 className="mu-item__title">
              {videoData.ShortHeadline && videoData.ShortHeadline.value}
            </h1>
            {videoData.VideoFileTranscript && videoData.VideoFileTranscript.value && (
              <a className="transcript" href="#" onClick={(e) => toggleTranscript(e)}>
                <span className="mu-item__video-link" tabIndex="0">
                  <span>{t('Transcript')}</span>
                </span>
              </a>
            )}
            <p className="mu-item__teasure">{videoData.Teaser && videoData.Teaser.value}</p>
            {videoData.UpsellMapping && <UpSell data={videoData.UpsellMapping} />}
          </div>
          <StatsBar
            classes="statsbar non-destination"
            item={getStatsBarData(videoData)}
            noTags={true}
            upSellData={videoData.UpsellMapping}
          />
          {showTranscript && (
            <Transcript
              toggleTranscript={toggleTranscript}
              transcriptOnkeypress={transcriptOnkeypress}
              videoFileTranscript={videoData.VideoFileTranscript}
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default withTranslation()(VideoDetailModal);
